export default {
  drawAreaPt(currentMap, type) {
    let bkData = JSON.parse(sessionStorage.getItem("xfsbk_data"));
    let importPt = JSON.parse(sessionStorage.getItem("xfsbk_location"));
    console.log("选房师板块配套地图", bkData);
    let dots = bkData.dots.split("-").map((x) => {
      return x.split("|");
    });
    let polygon = new AMap.Polygon({
      path: dots,
      fillOpacity: 0,
      strokeWeight: 5,
      strokeOpacity: 1,
      strokeStyle: "dashed",
      strokeColor: "#333333",
    });
    currentMap.add(polygon);
    currentMap.setFitView([polygon], false, [0, 0, 0, 0]);

    if (importPt) {
      if (importPt.trafficList && (type === "交通" || type === "全部")) {
        this.addAreaPt(importPt.trafficList, "#ff8a25", "交", currentMap);
      }
      if (importPt.schoolList && (type === "学校" || type === "全部")) {
        this.addAreaPt(importPt.schoolList, "#0087f9", "学", currentMap);
      }
      if (importPt.marketList && (type === "商场" || type === "全部")) {
        this.addAreaPt(importPt.marketList, "#6d27f6", "商", currentMap);
      }
      if (importPt.hospitalList && (type === "医院" || type === "全部")) {
        this.addAreaPt(importPt.hospitalList, "#00d1fc", "医", currentMap);
      }
      if (importPt.sceneryList && (type === "景观" || type === "全部")) {
        this.addAreaPt(importPt.sceneryList, "#00fd3f", "景", currentMap);
      }
      if (importPt.publicList && (type === "文化" || type === "全部")) {
        this.addAreaPt(importPt.publicList, "#ff06b7", "文", currentMap);
      }
    }
    currentMap.setZoom(14);
  },
  addAreaPt(arr, color, type, currentMap) {
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index];
      let markerContent = ` <div style="background-color:${color};
                width: 5px;
                height: 5px;
                border-radius: 50%;
                position: relative;
                font-size: 14px;
                color: #fff;
                text-align: left;
                font-style: normal;
                text-transform: none;
                line-height: 18px;
                z-index: 105;">
            <div style="background-color:${color};
              position: absolute;
              padding: 5px 10px;
              top: -4px;
              left: 50%;
              transform: translate(-50%, -100%);">
              ${type}
              <div style="border-top:5px solid ${color};
                  position: absolute;
                  bottom: 0px;
                  left: 50%;
                  transform: translate(-50%, 70%);
                  width: 0;
                  height: 0;
                  border-left: 5px solid transparent;
                  border-right: 5px solid transparent;"></div>
            </div>
          </div>`;
      let marker = new AMap.Marker({
        position: element.lnglat.split("-")[0].split("|"),
        content: markerContent,
        offset: new AMap.Pixel(0, 0),
        draggable: true,
        zIndex: 120,
        type: type,
      });
      currentMap.on("zoomchange", function () {
        var currentZoom = currentMap.getZoom(); // 获取当前缩放级别
        if (currentZoom > 14) {
          marker.setContent(
            `<div style="background-color:${color};
                width: 5px;
                height: 5px;
                border-radius: 50%;
                position: relative;
                font-size: 14px;
                color: #fff;
                text-align: left;
                font-style: normal;
                text-transform: none;
                line-height: 18px;
                z-index: 105;">
              <div style="background-color:${color};
                position: absolute;
                padding: 5px 10px;
                top: -4px;
                left: 50%;
                transform: translate(-50%, -100%);">
                ${element.location_name}
                <div style="border-top:5px solid ${color};
                  position: absolute;
                  bottom: 0px;
                  left: 50%;
                  transform: translate(-50%, 70%);
                  width: 0;
                  height: 0;
                  border-left: 5px solid transparent;
                  border-right: 5px solid transparent;"></div>
              </div>
            </div>`
          );
        } else {
          marker.setContent(
            ` <div style="background-color:${color};
                width: 5px;
                height: 5px;
                border-radius: 50%;
                position: relative;
                font-size: 14px;
                color: #fff;
                text-align: left;
                font-style: normal;
                text-transform: none;
                line-height: 18px;
                z-index: 105;">
                <div style="background-color:${color};
                  position: absolute;
                  padding: 5px 10px;
                  top: -4px;
                  left: 50%;
                  transform: translate(-50%, -100%);">
                  ${type}
                  <div style="border-top:5px solid ${color};
                    position: absolute;
                    bottom: 0px;
                    left: 50%;
                    transform: translate(-50%, 70%);
                    width: 0;
                    height: 0;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;"></div>
                </div>
              </div>`
          );
        }
      });
      marker.setMap(currentMap);
    }
  },
  changeColor(type) {
    this.pttype = type;
    this.currentMap.clearMap();
    this.drawAreaPt(this.currentMap, type);
  }
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindFacility.js